var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
  'background': _vm.data.infoItme.bjColor,
  'padding': ((_vm.data.infoItme.sBj) + " " + (_vm.data.infoItme.yeBj) + " " + (_vm.data.infoItme.xBj))
})},[_c('el-carousel',{attrs:{"trigger":"click"}},_vm._l((_vm.data.carouselImage),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.src ? item.src : _vm.imgSrc}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(item.title))])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-114c9760","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/carouselView.vue
// module id = null
// module chunks = 